import React from "react";
import { Row } from "react-bootstrap";
import Success360Card from "./Success360Card";

export default function ListSuccess360({ dataList, handleDelete, handleEdit }) {
  if (!dataList || dataList.length === 0) {
    return (
      <div className="text-center py-5">
        <div className="fs-1 text-muted">No Success360 Plans Found</div>
        <div className="text-muted">Add some plans to get started</div>
      </div>
    );
  }

  return (
    <Row className="g-3">
      {dataList.map((data, idx) => (
        <Success360Card
          key={data.id || idx}
          data={data}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
        />
      ))}
    </Row>
  );
}
